import Immutable from 'immutable';
import actionTypes from './constants';

////////////////// EDIT //////////////////

const $$initialState = Immutable.fromJS({
  submit_params: Immutable.Map({
    external_account: '',
    legal_entity: Immutable.Map({
      address: Immutable.Map({
        city: '',
        line1: '',
        postal_code: '',
        state: '',
      }),
      business_name: '',
      business_tax_id: '',
      dob: Immutable.Map({
        day: '',
        month: '',
        year: '',
      }),
      first_name: '',
      last_name: '',
      ssn_last_4: '',
      type: 'company',
    }),
    tos_acceptance: Immutable.Map({}),
  }),
  bank_account_info: Immutable.Map({
    country: 'US',
    currency: 'USD',
    routing_number: '',
    account_number: '',
    account_holder_name: '',
  }),
  stripe_error: '',
  ssn_error: '',
  submit_button_enabled: false,
  info_box_enabled: true,
  show_spinner: false,
});

////////////////// EDIT //////////////////

function appReducer($$state = $$initialState, action) {
  const { payload } = action;

  switch (action.type) {
    case actionTypes.UPDATE_INPUT_FIELD:
      return $$state.updateIn(payload.path, val => payload.value);
    case actionTypes.SHOW_SUBMIT_BUTTON:
      return $$state.updateIn(['submit_button_enabled'], val => payload.bool);
    case actionTypes.FILL_INFO_QA:
      const path = ['submit_params', 'legal_entity'];
      return $$state.withMutations(map => {
        map
          .updateIn([...path, 'address', 'line1'], val => '3180 18th St')
          .updateIn([...path, 'address', 'city'], val => 'San Francisco')
          .updateIn([...path, 'address', 'state'], val => 'CA')
          .updateIn([...path, 'address', 'postal_code'], val => '94110')
          .updateIn([...path, 'business_name'], val => 'Business Name')
          .updateIn([...path, 'dob', 'day'], val => '25')
          .updateIn([...path, 'dob', 'month'], val => '7')
          .updateIn([...path, 'dob', 'year'], val => '1970')
          .updateIn([...path, 'first_name'], val => 'Jonathan')
          .updateIn([...path, 'last_name'], val => 'Goode')
          .updateIn([...path, 'ssn_last_4'], val => '0000');
      });
    default:
      return $$state;
  }
}

////////////////// PERMANENT //////////////////
export default {
  $$appStore: appReducer,
};

export const initialStates = {
  $$initialState,
};
